import React, { FC } from 'react'

import { TSignalType } from 'common/types'

import { FeedbackPageView } from './FeedbackPageView'
import { useFeedbackPage } from '../hooks/useFeedbackPage'

export const FeedbackPage: FC<{ type: TSignalType }> = ({ type }) => {
  const { feedbackContent, onClick } = useFeedbackPage(type)

  return <FeedbackPageView content={feedbackContent} onClick={onClick} type={type} />
}
